import React from "react";
import { Link } from "react-router-dom";
import { Product, totalStock } from "../types";

interface ProductCardProps {
  product: Product;
}

const ProductCard: React.FC<ProductCardProps> = ({ product }) => {
  const stock = totalStock(product.sizes_json);
  const isOutOfStock = stock === 0;
  const image = product.images_json?.[0];

  return (
    <Link
      to={`/products/${product.id}`}
      className="group block"
      aria-label={product.name}
    >
      {/* Image container */}
      <div className="relative aspect-[3/4] bg-ks-card overflow-hidden mb-4">
        {image && (
          <img
            src={image}
            alt={product.name}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            loading="lazy"
          />
        )}

        {/* Out of stock overlay */}
        {isOutOfStock && (
          <div className="absolute inset-0 bg-ks-bg/70 flex items-center justify-center">
            <span className="font-saira uppercase tracking-widest text-xs text-ks-secondary border border-ks-border px-3 py-1">
              Sold Out
            </span>
          </div>
        )}

        {/* Quick view hint on hover */}
        {!isOutOfStock && (
          <div className="absolute bottom-0 left-0 right-0 bg-ks-bg/80 py-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300 flex items-center justify-center">
            <span className="font-saira uppercase tracking-widest text-xs text-ks-text">
              View Product
            </span>
          </div>
        )}
      </div>

      {/* Info */}
      <div>
        <h3 className="font-saira uppercase tracking-wide text-ks-text text-base leading-tight group-hover:text-ks-warm transition-colors">
          {product.name}
        </h3>
        {isOutOfStock && (
          <p className="font-montserrat text-ks-muted text-xs mt-1">
            Out of stock
          </p>
        )}
      </div>
    </Link>
  );
};

export default ProductCard;
